<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div
        class="card-header align-items-center justify-content-between border-0"
      >
        <h5 class="card-title font-bold mb-0">
          تنظیمات خرید امتیازات باشگاه
        </h5>

        <button
          :disabled="disabled"
          type="button"
          @click="submitChanges"
          class="btn btn-success"
        >
          ثبت تغییرات
        </button>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="club-setting">
              <div class="club-setting-content">
                <div class="club-setting-title">
                  خرید امتیازات باشگاه
                </div>

                <div class="club-setting-description">
                  با فعال بودن این گزینه، کاربران می‌توانند امتیازات باشگاه
                  خریداری کنند.
                </div>
              </div>

              <label class="custom-switch">
                <input
                  type="checkbox"
                  v-model="customers_club_is_active"
                  :disabled="disabled"
                />
                <span class="custom-switch-slider"></span>
              </label>
            </div>

            <div
              class="mt-3 alert"
              :class="
                customers_club_is_active ? 'alert-success' : 'alert-warning'
              "
            >
              <span v-if="customers_club_is_active">
                خرید امتیازات باشگاه فعال است.
              </span>

              <span v-else>
                خرید امتیازات باشگاه غیرفعال است.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import ActivateClubImpl from "@@/core/pages/customerClub/clubSettings/activateClub/ActivateClubImpl.js";

export default {
  extends: ActivateClubImpl,
};
</script>

<style scoped>
.club-setting {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 20px;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  background: #fff;
}

.club-setting-title {
  font-size: 16px;
  font-weight: 700;
  color: #343a40;
}

.club-setting-description {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.8;
  color: #868e96;
}

/* Switch */
.custom-switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
  flex-shrink: 0;
  margin: 0;
}

.custom-switch input {
  width: 0;
  height: 0;
  opacity: 0;
}

.custom-switch-slider {
  position: absolute;
  inset: 0;
  cursor: pointer;
  border-radius: 30px;
  background: #ced4da;
  transition: 0.25s;
}

.custom-switch-slider::before {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  left: 3px;
  top: 3px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  transition: 0.25s;
}

.custom-switch input:checked + .custom-switch-slider {
  background: #28a745;
}

.custom-switch input:checked + .custom-switch-slider::before {
  transform: translateX(24px);
}

.custom-switch input:disabled + .custom-switch-slider {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
